import { IconComponent } from "../icon.types";

export const CircleIcon: IconComponent = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" {...props}>
        <circle cx="5" cy="5" r="4.5" fill="currentColor" />
    </svg>
);
